module.exports = __webpack_public_path__ + "static/media/metro-cart.e4c18b94.svg";